import { z } from "zod";

export const TenantConfigResponseSchema = z.object({
  providerId: z.string().optional(),
});
